import { FC } from 'react';

import { AvailableCurrencies, CURRENCY_SYMBOLS, formatCost } from 'utils/clickme';
import { NON_BREAKING_SPACE } from 'utils/constants/common';

import { VSpacingContainer } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { BalanceInfoRow } from 'components/common/BalanceCardContent/BalanceInfoRow/BalanceInfoRow';

import { selectNeedTopUp } from 'store/models/stoppedCampaigns';
import { useSelector } from 'store/utils';

const TrlKeys = {
    balance: 'Header.HeaderBalanceDrop.balance',
    topUp: 'Header.HeaderBalanceDrop.topUp',
    reservedBalance: 'Header.HeaderBalanceDrop.reservedBalance',
    reservedBalanceTooltip: 'Header.HeaderBalanceDrop.reservedBalanceTooltip',
    availableBalance: 'Header.HeaderBalanceDrop.availableBalance',
    availableBalanceTooltip: 'Header.HeaderBalanceDrop.availableBalanceTooltip',
    needTopUp: 'Header.HeaderBalanceDrop.needTopUp',
    needTopUpTooltip: 'Header.HeaderBalanceDrop.needTopUpTooltip',
};

export const BalanceCardBottom: FC = () => {
    const { reservedBalance, availableBalance } = useSelector(({ balance }) => balance);
    const needTopUp = useSelector(selectNeedTopUp);

    const trls = useTrls();

    return (
        <VSpacingContainer default={8}>
            <BalanceInfoRow
                label={trls(TrlKeys.reservedBalance)}
                tooltipText={trls(TrlKeys.reservedBalanceTooltip)}
                amount={reservedBalance}
                amountDataQa="balance-card-reserved-balance"
            />
            {needTopUp && (
                <BalanceInfoRow
                    label={trls(TrlKeys.needTopUp)}
                    tooltipText={trls(TrlKeys.needTopUpTooltip, [
                        `${formatCost(Math.abs(availableBalance), NON_BREAKING_SPACE)}${NON_BREAKING_SPACE}${
                            CURRENCY_SYMBOLS[AvailableCurrencies.RUR]
                        }`,
                    ])}
                    amount={Math.abs(availableBalance)}
                    amountDataQa="balance-card-need-top-up"
                    isNegative
                />
            )}
            {availableBalance >= 0 && (
                <BalanceInfoRow
                    label={trls(TrlKeys.availableBalance)}
                    tooltipText={trls(TrlKeys.availableBalanceTooltip)}
                    amount={availableBalance}
                    hideCurrency
                    amountDataQa="balance-card-available-balance"
                />
            )}
        </VSpacingContainer>
    );
};
